import { observer } from 'mobx-react-lite'
import { Alert } from 'shared/ui'
import { type IGuidelineStore } from '../store/GuidelineAlertStore'

export type IGuidelineAlertProps = {
  className?: string
  store: IGuidelineStore
  message: string
  link: string
}

export const GuidelineAlert = observer(
  ({ className, store, message, link }: IGuidelineAlertProps) => {
    if (store.hidden) return null

    return (
      <Alert
        className={className}
        item={{
          type: 'infoBlue',
          desc: message,
        }}
        rightActions={[
          {
            variant: 'link',
            type: 'primary',
            text: 'Learn more',
            link,
          },
        ]}
        onClose={() => store.hide()}
      />
    )
  }
)
